import { render, staticRenderFns } from "./CompanyInvitation.vue?vue&type=template&id=39e01afe"
import script from "./CompanyInvitation.vue?vue&type=script&lang=js"
export * from "./CompanyInvitation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports